import React from 'react';
import c from '../w.js';

const IconYen = React.memo(
  c(
    /* @__PURE__ */ React.createElement("path", { d: "M9.65571 5.90909H7.1756L10.2054 12.3267H7.981V13.7649H10.7935V14.858H7.981V16.2962H10.7935V19H13.1458V16.2962H15.8304V14.858H13.1458V13.7649H15.8304V12.3267H13.785L16.8212 5.90909H14.3411L12.0016 11.3871L9.65571 5.90909Z" })
  )
);

export { IconYen };
